import { Subject } from 'rxjs';
import { DeferredData, Rpc } from '../rpc';
import { RpcSubjectServer } from '../rpc-subject-server';
import { RpcAliveHandler } from './rpc-alive-handler';
import { RpcAliveData, RpcAliveKey } from './rpc-alive-model';

/**
 * RpcAlive subject interface.
 */
export interface RpcAliveSubject extends Subject<DeferredData<RpcAliveData, void>> {}

/**
 * The class to implement RpcAlive with Subject server.
 */
export class RpcAliveSubjectServer extends RpcSubjectServer<RpcAliveData, void> implements RpcAliveHandler {
    /**
     * Initializes a new instance of the RpcAliveSubjectServer class.
     *
     * @param rpc the Rpc instance.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcAliveKey.command);
    }

    /**
     * The handler to respond a request for RpcAlive call.
     *
     * @param data The RPC alive data object.
     * @returns return the Promise<void> object.
     */
    public handler(data: RpcAliveData): Promise<void> {
        return this.processNextForSubject(RpcAliveKey.command, data);
    }
}
